import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Carousel, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './Home.css';

import homeImg4 from '../../assets/HomePhotos/homeImg4.jpg';
import homeImg5 from '../../assets/HomePhotos/homeImg5.png';
import homeImg6 from '../../assets/HomePhotos/homeImg6.jpg';
import homeImg7 from '../../assets/HomePhotos/homeImg7.jpg';
import homeImg8 from '../../assets/HomePhotos/homeImg8.png';
import homeImg9 from '../../assets/HomePhotos/homeImg9.png';
import homeImg10 from '../../assets/HomePhotos/homeImg10.png';
import homeImg11 from '../../assets/HomePhotos/homeImg11.jpg';

import homeIcon1 from '../../assets/HomePhotos/homeIcon1.png';
import homeIcon2 from '../../assets/HomePhotos/homeIcon2.png';
import homeIcon3 from '../../assets/HomePhotos/homeIcon3.png';
import homeIcon4 from '../../assets/HomePhotos/homeIcon4.png';

const getSlug = (title) => {
  return title.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Changes everything that are not letters and numbers to slashes
    .replace(/(^-|-$)/g, '');    // Removes slashes on start and end
};

const Home = () => {
  const [index, setIndex] = useState(0);
  const [rentals, setRentals] = useState([]);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };


  useEffect(() => {
    const fetchRentals = async () => {
      try {
        //const response = await fetch('http://localhost:5000/api/all-properties');
        const response = await fetch('/api/all-properties');
        if (response.ok) {
          const data = await response.json();
          setRentals(data);
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };
    fetchRentals();
  }, []);

  //For section 6
  const featureSlides = [
    {
      id: 1,
      subtitle: "PLAY",
      title: "Life Just Got Better.",
      img: homeImg8
    },
    {
      id: 2,
      subtitle: "LIVE",
      title: "AMENITIES COME ALIVE IN EXCITING SPACES",
      img: homeImg9
    },
    {
      id: 3,
      subtitle: "EXPLORE",
      title: "Location, Community, Quality Living. It Starts Here!",
      img: homeImg10
    }
  ];

  return (
    <div className="home-page">
      {/* --- Section 1 ------------------------------------------------------- */}
      <section className="hero-section">
        
        {/* Progress bar */}
        <div className="carousel-progress-container">
          <div className="carousel-progress-bar" key={index}></div>
        </div>

        <div className="custom-caption-container">
          <Container>
            <Row>
              <Col md={7} lg={6} className="text-start ps-4">
                <span className="subtitle-top animate-fade">Best locations.</span>
                <h1 className="hero-title animate-fade">
                  Where <br />
                  Dreams <br />
                  <span className="highlight">Come Home.</span>
                </h1>
                <Button 
                  as={Link} 
                  to="/about-us" 
                  className="explore-btn mt-4 animate-fade"
                >
                  explore now
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        <Carousel 
          activeIndex={index}
          onSelect={handleSelect}
          fade 
          controls={false} 
          indicators={true} 
          interval={10000} 
          pause={false}
          className="hero-carousel"
        >
          {[1, 2, 3].map((slideNum) => (
            <Carousel.Item key={slideNum}>
              <div className="carousel-image-container">
                <div className={`zoom-image home-slide-${slideNum}`}></div>
                <div className="overlay"></div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      {/* --- Section 2 ------------------------------------------------------- */}
      <section className="about-section pt-5 pb-0">
        <Container>
          <Row className="align-items-center">

            {/* Picture on left */}
            <Col lg={6} className="mb-4 mb-lg-0 d-flex justify-content-center">
              <div className="about-image-wrapper">
                <img src={homeImg4} alt="Happy Dream Home" className="img-fluid custom-about-img" />
              </div>
            </Col>
            {/* Text on right */}
            <Col lg={6} className="ps-lg-5 text-start pb-5">
              <h2 className="about-title mb-4">ABOUT HAPPY DREAM</h2>
              <div className="about-text">
                <p>
                  <b>
                  Since 2019 Happy Dream has provided safe, sound, and well-maintained homes 
                  to our tenants while providing them a high level of service and professionalism.
                  </b>
                </p>
                <p>
                  <b>
                  We leverage technology and local service personnel to serve our tenants 
                  around the clock. We pride ourselves on delivering same day responses to 
                  tenant questions, concerns, and, most importantly, service requests.
                  </b>
                </p>
                <p>
                  <b>
                  Our mission is for our tenants to call their Happy Dream Property
                  “Home Sweet Home” for years to come.
                  </b>
                </p>
                <p>
                  <b>
                  Discover a lifestyle that combines the tranquility of nature with the 
                  convenience of urban living.
                  </b>
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="full-width-divider mt-4">
          <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>
      </section>

      {/* --- Section 3 ------------------------------------------------------- */}
      <section className="layouts-section pt-5 pb-0">
        <Container>
          <Row className="align-items-center">
            
            {/* Left text */}
            <Col lg={6} className="text-start pe-lg-5 mb-4 mb-lg-0">
              <h2 className="layouts-title mb-4">Available Layouts</h2>
              <div className="layouts-text">
                <p>
                  From light and flow to pure square footage, there’s a lot to consider 
                  when you’re looking for the next place to call home. Take a look at 
                  the life that awaits as you browse the gallery of our layouts for rent.
                </p>
                <p>
                  From Granite countertops and designer finishes to large, floor-to-ceiling 
                  windows, we’ve put thought into every single detail of our units.
                </p>
              </div>
            </Col>

            {/* Right picture */}
            <Col lg={6} className="d-flex justify-content-center">
              <div className="layouts-image-wrapper">
                <img 
                  src={homeImg6} 
                  alt="Interior Layout" 
                  className="img-fluid custom-layouts-img" 
                />
              </div>
            </Col>
          </Row>
        </Container>

        <div className="full-width-divider mt-5">
          <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>
      </section>

      {/* --- Section 4 ------------------------------------------------------- */}
      <section className="rentals-section pt-5 pb-0">
        <Container>
          <h2 className="rentals-main-title text-center mb-5">Available Rental Locations</h2>
          
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            breakpoints={{
              // 768px (tablet)
              768: { slidesPerView: 2 },
              // 1024px (desktop)
              1024: { slidesPerView: 4 },
            }}
            className="pb-5" // Space for pagination (dots)
          >
            {rentals.map((item) => {
              const displayImg = item.images && item.images.length > 0 
                //? `http://localhost:5000/uploads/${item.images[0].replace(/\\/g, '/').replace('uploads/', '')}`
                ? `/api/uploads/${item.images[0].replace(/\\/g, '/').replace('uploads/', '')}`
                : 'https://via.placeholder.com/400x300?text=No+Image';

              return (
                <SwiperSlide key={item.id}>
                  <Card className={`rental-card h-100 border-0 ${!item.isAvailable ? 'leased-card' : ''}`}>
                    <div className="rental-img-container">
                      {/* --- STATUS BADGE --- */}
                      <div className={`property-status-tag ${item.isAvailable ? 'status-available' : 'status-leased'}`}>
                        {item.isAvailable ? 'AVAILABLE' : 'LEASED'}
                      </div>

                      <Card.Img 
                        variant="top" 
                        src={displayImg} 
                        className="rental-img" 
                        style={{ filter: item.isAvailable ? 'none' : 'grayscale(30%) opacity(0.8)' }}
                      />
                      
                      <div className="rental-overlay">
                        <Link to={`/project/${getSlug(item.title)}`} className="view-btn-overlay">
                          {item.isAvailable ? 'View Details' : 'View Property'}
                        </Link>
                      </div>
                    </div>

                    <Card.Body className="text-start d-flex flex-column">
                      <Card.Title className="rental-unit-title d-flex justify-content-between align-items-center">
                        {item.title}
                        {/* Small dot in color next to title */}
                        <span className={`status-dot ${item.isAvailable ? 'bg-success' : 'bg-danger'}`}></span>
                      </Card.Title>
                      <Card.Text className="rental-location-text mb-3">
                        <i className="bi bi-geo-alt-fill me-1"></i> {item.location}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Container>

        <div className="full-width-divider mt-5">
          <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>
      </section>

      {/* --- Section 5 ------------------------------------------------------- */}
      <section className="community-section pt-5 pb-0">
        <Container>
          <Row className="align-items-center">
            
            {/* Image on the left */}
            <Col lg={6} className="mb-4 mb-lg-0 d-flex justify-content-center">
              <div className="community-image-wrapper">
                <img 
                  src={homeImg7} 
                  alt="Community and Neighborhood" 
                  className="img-fluid custom-community-img" 
                />
              </div>
            </Col>

            {/* Text on the right */}
            <Col lg={6} className="ps-lg-5 text-start">
              <h2 className="community-title mb-4">Community</h2>
              <div className="community-text">
                <p>
                  We're committed to being a responsible member of society and taking 
                  care of those who help make our ongoing success possible. We believe 
                  that as an organization we are proud of every neighborhood we develop, 
                  build and manage.
                </p>
                <p>
                  From start to finish, we serve as a full-service developer, using the 
                  skills of our capable, professional staff to drive projects to close 
                  thoroughly and efficiently.
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="full-width-divider mt-5">
          <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>
      </section>

      {/* --- Section 6 ------------------------------------------------------- */}
      <section className="features-section bg-white pt-5 pb-0">
        <Container>
          <Carousel 
            fade 
            controls={false} 
            indicators={true} 
            interval={7000} 
            className="features-carousel-clean"
          >
            {featureSlides.map((slide) => (
              <Carousel.Item key={slide.id}>
                <Row className="align-items-center g-0">
                  
                  {/* Picutre on the left */}
                  <Col md={6} className="pe-md-5">
                    <div className="fixed-image-wrapper">
                      <div className="feature-zoom-container">
                        <img 
                          src={slide.img} 
                          alt={slide.subtitle} 
                          className="feature-img-fixed" 
                        />
                      </div>
                      {/* Shadow for picture */}
                      <div className="feature-shadow-bg"></div>
                    </div>
                  </Col>

                  {/* Text for the right side*/}
                  <Col md={6} className="text-start ps-md-3 mt-4 mt-md-0">
                    <h6 className="feature-subtitle-clean">{slide.subtitle}</h6>
                    <h2 className="feature-title-clean">{slide.title}</h2>
                  </Col>

                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>

        <div className="full-width-divider-bottom">
          <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>
      </section>

      {/* --- Section 7 ------------------------------------------------------- */}
      <section className="project-management-section pt-5 pb-0">
        <Container>
          <Row className="align-items-center">
            
            {/* Text on left */}
            <Col md={6} className="text-start pe-md-5 mb-4 mb-md-0">
              <h2 className="management-title mb-4">Project Management</h2>
              <div className="management-text">
                <p>
                  Many people don’t realize leasing a rental property is a full-time job. 
                  When questions arise, you could rely on a Google search, and your best 
                  friend’s advice, or you could rely on the knowledge, experience, and 
                  expertise of the Staff at Happy Dream.
                </p>
                <p>
                  Our top priority is to provide excellent customer service to our 
                  tenants while providing comfort and convenience to our owners.
                </p>
              </div>
            </Col>

            {/* Picture on right */}
            <Col md={6} className="ps-md-5 d-flex justify-content-end">
              <div className="management-image-wrapper">
                <img 
                  src={homeImg11} 
                  alt="Project Management" 
                  className="img-fluid custom-management-img" 
                />
                {/* Shadow */}
                <div className="management-shadow-bg"></div>
              </div>
            </Col>

          </Row>
        </Container>

        <div className="full-width-divider-bottom mt-5">
          <img src={homeImg5} alt="Decorative Divider" className="divider-img" />
        </div>
      </section>
      
      {/* --- Section 8 ------------------------------------------------------- */}
      <section className="perks-section py-5 bg-white">
        <Container className="py-5">
          <h2 className="perks-main-title text-center mb-5">PERKS</h2>
          
          <Row className="g-5">
            
            {/* PERK 1 */}
            <Col md={6} className="text-start perk-item">
              <div className="perk-icon-wrapper">
                <img src={homeIcon1} alt="Move In Reports" className="perk-icon" />
              </div>
              <h4 className="perk-title">MOVE IN / MOVE OUT REPORTS</h4>
              <p className="perk-text">
                Each property is photographed before and after tenants take possession to document any damage that has been incurred. 
                A detailed checklist is also used, and each room is inspected closely to document damage or irregularities.
              </p>
            </Col>

            {/* PERK 2 */}
            <Col md={6} className="text-start perk-item">
              <div className="perk-icon-wrapper">
                <img src={homeIcon2} alt="Maintenance" className="perk-icon" />
              </div>
              <h4 className="perk-title">MAINTENANCE</h4>
              <p className="perk-text">
                We can handle maintenance problems of every kind, relying on our own handymen and a stable of contractors to ensure 
                quality work, quick turnaround and competitive pricing. Our team is always available for contact using our Service desk feature.
              </p>
            </Col>

            {/* PERK 3 */}
            <Col md={6} className="text-start perk-item">
              <div className="perk-icon-wrapper">
                <img src={homeIcon3} alt="Leasing Services" className="perk-icon" />
              </div>
              <h4 className="perk-title">FULL LEASING SERVICES, INCLUDING TENANT SCREENING</h4>
              <p className="perk-text">
                Available rental properties are placed on our online site along with apartments.com. We also use other tenant placement 
                companies to help get the most exposure possible. Prospective tenants are screened for prior evictions, judgments, 
                liens, bankruptcies, and credit worthiness.
              </p>
            </Col>

            {/* PERK 4 */}
            <Col md={6} className="text-start perk-item">
              <div className="perk-icon-wrapper">
                <img src={homeIcon4} alt="Financial Statements" className="perk-icon" />
              </div>
              <h4 className="perk-title">MONTHLY AND ANNUAL FINANCIAL STATEMENTS</h4>
              <p className="perk-text">
                Every month we send you a statement showing your rental income and expenses for each specific property. 
                We also provide you with a 1099 at the end of the year, as required by law.
              </p>
            </Col>

          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;